import type { AssistantUndoableDTO } from '@contracts/assistant';
import { Button } from '../../components/ui/button';
import { CANCEL_MISSION } from './missions/labels';

/**
 * Hana's command, undoable for its window (spec §8.1, D144, D187): one card for all its light writes, named by the
 * group summary (D188), and `Hoàn tác`, the same undo the toast
 * and ⌘Z offer. Once undone it reads 'Đã hoàn tác'; once the server says the undo is over, the button is gone.
 */
export function UndoCard({ undoable, done, gone, onUndo, onCancelMission }: {
  undoable: AssistantUndoableDTO; done: boolean; gone: boolean; onUndo: (u: AssistantUndoableDTO) => void;
  /** S7 G3: the undo was refused as stale on a mission — "Hủy nhiệm vụ" takes the place of Hoàn tác. */
  onCancelMission?: () => void;
}) {
  const button = 'h-auto min-h-11 rounded-[5px] px-2 py-[3px] text-xs lg:min-h-0';
  return (
    <div data-undo-card={undoable.groupId}
      className="mr-auto flex max-w-[92%] flex-wrap items-center gap-2 rounded-[9px] border border-[hsl(var(--h-border))] bg-[hsl(var(--h-card))] px-2 py-[5px] text-xs">
      <span className="min-w-0 flex-1 break-words text-[hsl(var(--h-card-foreground))]">{undoable.summary}</span>
      {done ? <span className="text-[hsl(var(--h-muted-foreground))]">Đã hoàn tác</span> : gone ? null
        : onCancelMission !== undefined ? (
          <Button type="button" variant="outline" className={button} onClick={onCancelMission}>{CANCEL_MISSION.action}</Button>
        ) : (
          <Button type="button" variant="outline" aria-keyshortcuts="Control+Z Meta+Z" className={button}
            onClick={() => onUndo(undoable)}>
            Hoàn tác
          </Button>
        )}
    </div>
  );
}
